import { InputPadrao, InputDatePicker, InputTimePicker } from './Inputs'
import { InputPrestador, InputPrestadorConselho } from './InputsAutoComplete'
import React, { useState, useEffect, useRef } from 'react'
import Yup from '../util/Validacoes'
import { mostrarToast } from './Toasts'
import { Formik, Form } from 'formik'
import { BotaoPadrao } from './Botoes'
import { mensagens } from '../util/Utilitarios'
import { salvar, excluir, consultar } from '../util/AcessoApi'
import '../assets/css/icones/iconsmind/style.css';
import { ModalCadastro } from './Modais'
import { BtnAcao, BtnAcaoConfirmarModal } from './Acoes'

const ModalBloqueioAgenda = (props) => {
    const [salvando, setSalvando] = useState(false)
    const refAtualizacao = useRef(null)
    const [bloqueios, setBloqueios] = useState([])
    const [prestador, setPrestador] = useState(null);
    const [carregando, setCarregando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')

    const [validacao, setValidacao] = useState(Yup.object({}))

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        salvar(
            { ...values },
            '/atendimento/bloqueioagenda',
            obj => {
                mostrarToast('sucesso', mensagens.sucesso)
                //     obterBloqueios(values.prestador);
                setValoresIniciais({});
                propsFormik.resetForm({});
                setSalvando(false);
                setPrestador(null)
                setBloqueios([])
            },
            (err) => {
                setSalvando(false)
            })
    }

    const obterBloqueios = (option) => {
        setCarregando(true);
        consultar('/atendimento/bloqueioagendacoop', val => {
            setBloqueios(val);
        }, null, { id: option?.pres_id, tipo: option?.tipo_prestador });
    }

    useEffect(() => {
        setValidacao(
            Yup.object({
                prestador: Yup.object().nullable().required(),
                data_inicial: Yup.string().nullable().required(),
                hora_inicial: Yup.string().nullable().required(),
                data_final: Yup.string().nullable().required(),
                hora_final: Yup.string().nullable().required()
            })
        )
        setPrestador(null);
    }, [props.abrirModal])

    useEffect(() => {
        if (prestador?.value)
            obterBloqueios(prestador)
        else
            setBloqueios([])
    }, [prestador])

    const setValoresLinha = (linha) => {
        setValoresIniciais(linha);
    }

    const sucessoExcluir = () => {
        obterBloqueios(prestador);
        mostrarToast('sucesso', mensagens.sucesso);
    }

    const erroExcluir = () => {
        mostrarToast('erro', mensagens.erro)
    }

    return (
        <>
            <ModalCadastro
                titulo={'Bloqueio de Agendamento'}
                show={props.abrirModal}
                setShowModal={props.setAbrirModal}>
                <Formik
                    initialValues={valoresIniciais}
                    validationSchema={validacao}
                    enableReinitialize={true}
                    onSubmit={(values, propsFormik) => Submit(values, propsFormik)}
                >
                    {(propsFormik) => (
                        <div ref={refAtualizacao}>
                            <Form>
                                <div className="modal-body-cadastro">
                                    <div class="separator mt-20 mb-20"></div>
                                    <div className={'form-group col-12 row pr-0'}>
                                        <>
                                            <InputPadrao
                                                label="Id"
                                                name="id"
                                                type="hidden"
                                                placeholder="Id"
                                                obrigatorio={true}
                                            />

                                            <InputPrestadorConselho
                                                label="Prestador"
                                                placeholder="Prestador"
                                                name="prestador"
                                                propsFormik={propsFormik}
                                                obrigatorio={true}
                                                tamanho={'col-12 p-0'}
                                                classeTooltip={'tooltip-input-modal'}
                                                focarAposSubmit={true}
                                                // salvarENovo={salvarENovo}
                                                onChangeOption={(option) => {
                                                    setPrestador(option);
                                                }}
                                                autoFocus
                                            />

                                            <InputDatePicker
                                                id={'data'}
                                                tamanho={'col-7 pl-0'}
                                                label="Data Inicial"
                                                name="data_inicial"
                                                type="text"
                                                obrigatorio="true"
                                                autoFocus
                                                setarValor={(value) => {
                                                    propsFormik.setFieldValue('data_inicial', value)
                                                }}
                                                classeTooltip={'tooltip-input-modal'}
                                                mostrarFeriado={false}
                                            />
                                            <InputTimePicker
                                                label="Hora Inicial"
                                                mascara="11:11"
                                                name="hora_inicial"
                                                type="text"
                                                placeholder="Hora Inicial"
                                                tamanho={'col-5 p-0'}
                                                obrigatorio={true}
                                                classeTooltip={'tooltip-input-modal'}
                                                setarValor={(value) => {
                                                    propsFormik.setFieldValue('hora_inicial', value)
                                                }}
                                            />

                                            <InputDatePicker
                                                id={'data'}
                                                tamanho={'col-7 pl-0'}
                                                label="Data Final"
                                                name="data_final"
                                                type="text"
                                                obrigatorio="true"
                                                setarValor={(value) => {
                                                    propsFormik.setFieldValue('data_final', value)
                                                }}
                                                classeTooltip={'tooltip-input-modal'}
                                                mostrarFeriado={false}
                                            />
                                            <InputTimePicker
                                                label="Hora Final"
                                                mascara="11:11"
                                                name="hora_final"
                                                type="text"
                                                placeholder="Hora Final"
                                                tamanho={'col-5 p-0'}
                                                classeTooltip={'tooltip-input-modal'}
                                                obrigatorio={true}
                                                setarValor={(value) => {
                                                    propsFormik.setFieldValue('hora_final', value)
                                                }}
                                            />
                                        </>
                                    </div>
                                </div>
                                {/* {carregando === true ? (
                                    <></>
                                ) : ( */}
                                <div className="mb-3 flex-end">
                                    <BotaoPadrao
                                        texto="Salvar"
                                        disabled={salvando}
                                        click={(_) => { }}
                                        idTooltip={'salvar'}
                                    />
                                </div>
                                {/* )} */}
                            </Form>
                        </div>
                    )}
                </Formik>
                <div>
                    <div className="modal-header">
                        <h5 className="modal-title"><span>Histórico de Bloqueios</span></h5>
                    </div>
                    {/* {carregando === true ? (
                                            <LoadRelatorio refLoading={refAtualizacao} heigth={320} />
                                        ) : props.item && props.item.id ? ( */}
                    {/* ) : (
                                        <></>
                                        )} */}
                    <div>
                        <ul className='lista-modal'>
                            {
                                bloqueios?.map(bloqueio =>
                                    <li className="mb-1">
                                        <div className='mt-2 row-space-between mb-2' style={{ flexDirection: 'row' }}>
                                            <div className='item-detalhes' style={{ flex: 1 }}>
                                                <h6><b>Data Inicial</b></h6>
                                                <h6 className='mb-1'>{bloqueio.data_inicial + (' ' + bloqueio.hora_inicial)}</h6>
                                            </div>
                                            <div className='item-detalhes mt-0 bl-cinza pl-1' style={{ flex: 1 }}>
                                                <h6><b>Data Final</b></h6>
                                                <h6 className='mb-1'>{bloqueio.data_final + (' ' + bloqueio.hora_final)}</h6>
                                            </div>
                                        </div>
                                        <div className="container-botao-direita card-row-agenda">
                                            <div className="mr-2">
                                                <BtnAcao classeContent="ml-1-between" icone="icon-Pen" texto="Alterar" action={_ => {
                                                    setValoresLinha(bloqueio)
                                                }} classTooltip="tooltip-input-modal z-index-max " />
                                            </div>
                                            <BtnAcaoConfirmarModal classeContent="ml-1-between z-index-max " icone="icon-New-Trash" texto="Excluir" classTooltip="tooltip-input-modal z-index-max "
                                                action={() => excluir('/atendimento/bloqueioagenda', bloqueio.id, sucessoExcluir, erroExcluir)} />
                                        </div>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </ModalCadastro >
        </>
    )
}

export default ModalBloqueioAgenda;